import React from "react";
import { useReactFlow } from "reactflow";
import { ZoomInOutlined, ZoomOutOutlined, ExpandOutlined } from "@ant-design/icons";

const FIT_VIEW_OPTIONS = { padding: 0.2, minZoom: 0.9, maxZoom: 1.5 };

export const WorkflowCustomControls: React.FC = () => {
    const { fitView, zoomIn, zoomOut } = useReactFlow();

    return (
        <div
            className="workflow-custom-controls"
            role="group"
            aria-label="Canvas zoom and fit controls"
        >
            <button
                type="button"
                onClick={() => zoomIn()}
                className="workflow-custom-controls__btn"
                aria-label="Zoom in"
                title="Zoom in"
            >
                <ZoomInOutlined />
            </button>
            <button
                type="button"
                onClick={() => zoomOut()}
                className="workflow-custom-controls__btn"
                aria-label="Zoom out"
                title="Zoom out"
            >
                <ZoomOutOutlined />
            </button>
            <button
                type="button"
                onClick={() => fitView(FIT_VIEW_OPTIONS)}
                className="workflow-custom-controls__btn"
                aria-label="Fit view"
                title="Fit to view"
            >
                <ExpandOutlined />
            </button>
        </div>
    );
};
